"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const button_1 = require("client/components/material/button");
const material_ui_1 = require("material-ui");
const React = require("react");
exports.Label = props => (React.createElement("div", { className: "heading-group", style: {
        // zIndex: props.onClick ? 1 : "auto"
        zIndex: 1
    } },
    React.createElement(material_ui_1.Typography, { variant: "body2" }, props.label),
    props.onClick ? (React.createElement(button_1.MaterialButton, { flat: true, secondary: true, onClick: props.onClick }, props.value)) : (React.createElement(material_ui_1.Typography, { variant: "body1" }, props.value)),
    props.children));



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-review/components/label/label.tsx
// module id = 3574
// module chunks = 0